import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Sidebar from "./components/Sidebar";
import Header from "./components/Header";

import Home from "./pages/Home";
import ContactUs from "./pages/ContactUs";
import PersonalLoan from "./pages/Loans/PersonalLoan";
import HomeLoan from "./pages/Loans/HomeLoan";
import BusinessLoan from "./pages/Loans/BusinessLoan";
import Girevance from "./pages/Loans/Girevance";
import AllLoans from "./pages/Loans/WebLeads";
import Dashboard from "./pages/DealX/Dashboard";
import RetailPartners from "./pages/DealX/RetailPartners";
import Reports from "./pages/DealX/Reports";
import Agents from "./pages/DealX/Agents";
import Customers from "./pages/DealX/Customers";
import LoanBook from "./pages/DealX/LoanBook"
import financeImage from "./assets/Login_graphic.png"
import LoanDetail from "./pages/Loans/LoanDetails";

import "./App.css";
import './cstm.style.css'

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userId, setUserId] = useState("");
  const [password, setPassword] = useState("");

  const handleLogin = (e) => {
    e.preventDefault();
    if (userId === "admin" && password === "123456") {
      setIsLoggedIn(true);
      localStorage.setItem("isLoggedIn", "true");
    } else {
      alert("Invalid credentials");
    }
  };
  const handleLogout = () => {
    setIsLoggedIn(false);
    setUserId("");
    setPassword("");
    // optional: clear persistence
    localStorage.removeItem("isLoggedIn");
  };

  if (!isLoggedIn) {
    return (
      <div className="login-container">
      {/* Left Image Section */}
      <div className="login-left-section">
        <img src={financeImage} alt="UTC Finance" className="login-hero-image" />
      </div>

      {/* Right Login Section */}
      <div className="login-right-section">
        <div className="login-content">
          <h1 className="login-main-title">UTC Finance</h1>
          {/* <p className="login-subtitle">
            Access your comprehensive loan management dashboard
          </p> */}
          {/* <p className="login-subtitle">
            Manage applications, track collections, and monitor KPIs
          </p> */}

          {/* Login Form */}
          <div className="login-box">
            <h2 className="login-box-title">Log into CRM</h2>
            <form className="login-form" onSubmit={handleLogin}>
              <div className="login-field-group">
                <label className="login-label">User ID</label>
                <input
                  type="text"
                  className="login-input login-userid-input"
                  value={userId}
                  onChange={(e) => setUserId(e.target.value)}
                  required
                />
              </div>
              <div className="login-field-group">
                <label className="login-label">Password</label>
                <input
                  type="password"
                  className="login-input login-password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="login-submit-btn">
                Login
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
    );
  }

  return (
    <Router>
      <div className="d-flex">
        {/* Sidebar stays visible on all pages */}
        <Sidebar onLogout={handleLogout}/>
        

        {/* Main Content Area */}
        <div className="flex-grow-1 remove-padding p-4">
          <Header title="UTC Finance Pvt. Ltd." userName="Akash Yadav" />
          <div className="app-main">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact-us" element={<ContactUs />} />

            {/* Loans */}
            <Route path="/loans/personal" element={<PersonalLoan />} />
            <Route path="/loans/home" element={<HomeLoan />} />
            <Route path="/loans/business" element={<BusinessLoan />} />
            <Route path="/loans/girevance" element={<Girevance />} />
            <Route path="/loans/webLeads" element={<AllLoans />} />
            <Route path="/loan/:table/:loanId" element={<LoanDetail />} />

            {/* DealX */}
            <Route path="/dealx/dashboard" element={<Dashboard />} />
            <Route path="/dealx/retail-partners" element={<RetailPartners />} />
            <Route path="/dealx/reports" element={<Reports />} />
            <Route path="/dealx/agents" element={<Agents />} />
            <Route path="/dealx/customers" element={<Customers />} />
            <Route path="/dealx/loan-book" element={<LoanBook />} />
            

            {/* Redirect any unknown route to home */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          </div>
        </div>
      </div>
    </Router>
  );
}
